import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import SlimFooter from "@/components/layout/SlimFooter";
import Ticker from "@/components/Ticker";
import CartDrawer from "@/components/CartDrawer";
import MallBar from "@/components/mall/MallBar";
import DemoBar from "@/components/product/DemoBar";
import { SiteMap } from "@/components/layout/SiteMap";

/** `designer` pages keep only the header, fill the screen, and end in a one-line footer. */
export default function Layout({ children, hideTicker, flatChrome, designer }) {
    return (
        <div className="App grain relative min-h-screen">
            <DemoBar />
            {!hideTicker && !designer && <Ticker />}
            <div className={flatChrome ? "bo-chrome" : undefined}>
                <Header />
                {!designer && <MallBar />}
            </div>
            <main className="flat relative z-[2]">{children}</main>
            {designer ? <SlimFooter /> : <div className="flat"><Footer /><SiteMap /></div>}
            <CartDrawer />
        </div>
    );
}
